import React from 'react';
import './Cards.css';
import CardItem from './CardItem';
import AyoDonasi from './CardsImages/donasi.png'
import BukaDonasi from './CardsImages/bukadonasi.png'
import { Link } from 'react-router-dom';

function Cards() {
  return (
    <div className='cards'>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              src={AyoDonasi}
              text='Kamu bisa mulai donasi di sini'
              label='Donasi'
              path="/ayo-donasi"
            />
            <CardItem
              src={BukaDonasi}
              text='Galang dana untuk mereka yang membutuhkan bantuan'
              label='Buka donasi'
              path="/buka-donasi"
            />
          </ul>
          <ul className='cards__items'>
          </ul>
        </div>
        <div id="category">
          <div className="title-category">
            <h3>Buka Donasi Bagi Mereka yang Membutuhkan Yuk!</h3>
          </div>
        </div>
        <br />
        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Elit sodales in malesuada parturient facilisis.
          Sagittis, leo, urna turpis libero nisl posuere pretium.
          Morbi sed pellentesque in auctor odio fringilla. Malesuada luctus feugiat risus in.
        </p>
        <button className="btn-2"><Link to="/Pelajari">Pelajari lebih lanjut</Link></button>
      </div>
    </div>
  );
}

export default Cards;
